import React from 'react';
import { Typography, Card, Button, Space } from 'antd';
import { CloudOutlined, CloudDownloadOutlined, HistoryOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const BackupManagement = () => {
  return (
    <div className="admin-module">
      <div className="admin-module-header">
        <Title level={3} className="admin-module-title">Backup Management</Title>
        <Text className="admin-module-description">
          Manage system backups, including creating backups and restoring data
        </Text>
      </div>

      <Card>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <CloudOutlined style={{ fontSize: '48px', color: '#096dd9', marginBottom: '16px' }} />
          <Title level={4}>Backup Management</Title>
          <Text type="secondary">This feature is under development, stay tuned...</Text>
          <br /><br />
          <Space>
            <Button type="primary" icon={<CloudDownloadOutlined />}>Create Backup</Button>
            <Button icon={<HistoryOutlined />}>Backup History</Button>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default BackupManagement; 